module.exports = __webpack_public_path__ + "media/new_goods_buy.cee6b75f.wav";